export const isAuthError = (response: Response) => response?.status === 401;
export const isInternalServerError = (response: Response) => response?.status === 500;
export interface ErrorResponse {
  data: unknown;
  response: Response;
}
